import { apiWrapper } from 'ccs-ui-components';
import { IRecordModel } from '../../../models';

/**
 * Custom hook to call exportEventConfiguration api
 * @returns promise
 */

const useExportEventConfiguration = () => {
  async function callExportEventConfiguration(eventList: IRecordModel[]) {
    const { responseBody, request, isError, error } = await apiWrapper.post<ArrayBuffer>(
      `${process.env.REACT_APP_API_BASE_URL}/exim/export`,
      {
        recordType: 'event',
        records: eventList,
      },
      undefined,
      undefined,
      'arraybuffer'
    );

    if (isError) {
      throw error;
    }

    return {
      data: responseBody,
      request
    };
  }

  const exportEventConfiguration = (eventList: IRecordModel[]) => callExportEventConfiguration(eventList);

  return { exportEventConfiguration };
};

export default useExportEventConfiguration;
